import { render, staticRenderFns } from "./bo-search-number.vue?vue&type=template&id=546c827f"
import script from "./bo-search-number.vue?vue&type=script&lang=js"
export * from "./bo-search-number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports